import * as React from "react";
import { MaterialProperty } from "../../../../../../smokepit/src/types/MaterialVolumes";
import { findMaterialInSurveys } from "./materialsVolumesChartUtils";

interface LineLabelProps {
  x?: number;
  y?: number;
  value?: number;
  index?: number;
  materialId: number;
  propertyLabel: string;
  hoveredMaterial: number | null;
  allSiteSurveysData: any[];
  selectedLayerLabel: string | null;
  formatAlreadyConvertedPropertyValue: (
    volume: number,
    prop: MaterialProperty
  ) => string;
  currentSurveyDateString: string | null;
  lineData: Record<string, string | number>[];
}

export const LineLabel: React.FC<LineLabelProps> = ({
  x,
  y,
  value,
  index,
  materialId,
  propertyLabel,
  hoveredMaterial,
  allSiteSurveysData,
  selectedLayerLabel,
  formatAlreadyConvertedPropertyValue,
  currentSurveyDateString,
  lineData,
}) => {
  if (hoveredMaterial !== materialId) {
    return null;
  }

  if (value === 0 || value == null || x == null || y == null || index == null) {
    return null;
  }

  const isCurrentSurvey = lineData[index]?.date === currentSurveyDateString;

  const material = findMaterialInSurveys(
    allSiteSurveysData,
    selectedLayerLabel,
    materialId
  );

  const prop = material?.properties?.find(
    (p: MaterialProperty) => p.property_label === propertyLabel
  );

  const formattedValue = prop
    ? formatAlreadyConvertedPropertyValue(value, prop)
    : value.toLocaleString();

  return (
    <text
      x={x}
      y={y - 12}
      fill={isCurrentSurvey ? "var(--neutral-1)" : "var(--neutral-3)"}
      fontSize={isCurrentSurvey ? 13 : 12}
      fontWeight={isCurrentSurvey ? "bold" : "normal"}
      fontFamily="var(--font-mono)"
      textAnchor="middle"
      dominantBaseline="text-after-edge"
    >
      {formattedValue}
    </text>
  );
};
